<template>
  <b-modal
    hide-footer
    id="modal-data-response"
    ref="modal-data-response"
    size="md"
    title="ข้อมูลตอบกลับ"
  >
    <div class="container">
      <b-card>
        <b-form-group>
          <label for="dataDescription">ข้อมูลตอบกลับ</label>
          <b-form-textarea v-model="obj.dataDescription" rows="8">
            <pre>{{ toPretty(obj.dataDescription) }}</pre>
          </b-form-textarea>
        </b-form-group>

        <b-form-group>
          <label for="message" class="mt-2">Message</label>
          <b-form-textarea v-model="obj.message" rows="3">
            <pre>{{ toPretty(obj.message) }}</pre>
          </b-form-textarea>
        </b-form-group>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
  },
  props: {
    obj: {
      dataDescription: "",
    },
  },
  methods: {
    onCancel() {
      this.$refs["modal-data-response"].hide();
    },
    toPretty(stringJson) {
      try {
        JSON.stringify(JSON.parse(stringJson), null, 2);
      } catch (ex) {
        return "";
      }
    },
  },
};
</script>

<style></style>
